import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import GroupDetails from './GroupDetails';
import { SkeltonCardTwo } from '../../../common/SkeltonCardTwo';
import { chatType } from '../ChatController';
import HelpDetails from './HelpDetails';
import { GroupMedia } from './Media/GroupMedia';
import { setSideBarMediaVisibleStatus } from '../../../actions/conversations';
import { getLookupWitHDefaultValue } from '../../../utils/common';
import { useLocation } from 'react-router-dom';
import { closeTutorialSteps } from '../../../actions/modal';
import { getChatMessages } from '../../../actions/chat';
import SideDrawer from '../../Ticket/SideDrawer';
import Details from '../../users/Details';

export default function ChatSideDrawer({ mainChatContanerRef }) {
    const dispatch = useDispatch();
    const location = useLocation();

    // Redux state
    const showSideBarMedia = useSelector((state) => state?.conversations.showSideBarMedia);
    const openedConversationId = useSelector((state) => state?.conversations.openedConversationId);
    const chatDetails = useSelector((state) => state.chat.chatDetails);
    const isConversationDetailsLoading = useSelector((state) => state?.loading.isConversationDetailsLoading);
    const isSingleChatUserDetailsLoading = useSelector((state) => state?.loading.isSingleChatUserDetailsLoading);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);

    // Local state
    const [isSearching, setIsSearching] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [showSearchedMessages, setShowSearchedMessages] = useState(false);
    const [checkedTracker, setCheckedTracker] = useState(() => new Set());

    const openedConversation = chatDetails?.[openedConversationId];
    const selectedMedia = useMemo(() => [...checkedTracker], [checkedTracker]);

    // Reset states when location changes
    useEffect(() => {
        setIsSearching(false);
        setSearchTerm('');
        setShowSearchedMessages(false);
        setCheckedTracker(() => new Set());
    }, [location?.pathname]);

    const setShowMedia = (status) => {
        dispatch(setSideBarMediaVisibleStatus(status));
    };

    const onKeyDownSearch = (e) => {
        if (e.key === "Enter" && searchTerm?.length > 0) {
            dispatch(closeTutorialSteps());
            setShowSearchedMessages(true);
            dispatch(getChatMessages({ id: openedConversationId, q: searchTerm, source: 'search' }));
        }
    };

    const SideBarComponent = useMemo(() => {
        if (!openedConversation?.type) return null;

        let user_id;
        if (openedConversation?.type === chatType.SINGLE && openedConversation?.members) {
            user_id = openedConversation?.members.find((member) => !member.is_ai_agent && member.id !== newLoggedUserData.user.id)?.id;
        }

        const sideBarLookup = getLookupWitHDefaultValue({
            lookup: {
                [chatType.GROUP]: GroupDetails,
                [chatType.TICKET]: SideDrawer,
                [chatType.SINGLE]: Details,
                [chatType.HELP]: HelpDetails,
            },
            defaultValue: () => GroupDetails,
        });

        const SideBar = sideBarLookup[openedConversation.type];

        return (
            <SideBar
                showMedia={showSideBarMedia}
                onKeyDownSeach={onKeyDownSearch}
                setShowMedia={setShowMedia}
                setIsSearching={setIsSearching}
                isSearching={isSearching}
                searchTerm={searchTerm}
                setSeachQuery={setSearchTerm}
                showSearchedMessages={showSearchedMessages}
                setShowSearchedMessages={setShowSearchedMessages}
                mainChatContanerRef={mainChatContanerRef}
                ticket_id={openedConversationId}
                user_id={user_id}
                hideCloseButton={true}
                isTicketChat={true}
            />
        );
    }, [openedConversation?.type, showSideBarMedia, isSearching, searchTerm, showSearchedMessages, mainChatContanerRef, openedConversationId, newLoggedUserData.user.id, openedConversation?.members]);

    // Render media view
    if (showSideBarMedia) {
        return <RenderFullSideViewMedia setShowMedia={setShowMedia} chat_id={openedConversationId} />
    }

    // Render loading state
    if (isConversationDetailsLoading || isSingleChatUserDetailsLoading) {
        return (
            <div className='px-6 py-4 bg-white rounded-md shadow-sm'>
                <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6, 7]} height={15} />
            </div>
        );
    }

    // Render sidebar component
    return (
        <div className='border-2 border-scogogray overflow-hidden rounded-md shadow-sm bg-white '>
            <div className='sidedrawer'>
                <div className='h-full'>{SideBarComponent}</div>
            </div>
        </div>
    );
}



export const RenderFullSideViewMedia = ({ setShowMedia, chat_id }) => {
    return (
        <div className="flex flex-col h-full">
            <div className='chatContainerHeader top-0 sticky flex w-full items-center z-50 justify-between bg-white shadow-sm'>
                <div
                    onClick={() => setShowMedia(false)}
                    className='hover:text-scogoorange hover:bg-gray-50 mx-2 pr-2 py-2 hover:shadow-md text-scogoprimary cursor-pointer flex items-center text-font20 rounded-md transition-all'
                >
                    <span className='material-icons m-0 font-bold'>chevron_left</span>
                    <span className='m-0 font-medium'>BACK</span>
                </div>

                {/* {selectedMedia?.length > 0 && (
                    <div className='mx-2 pr-2 py-1 text-scogoprimary flex gap-3 items-center rounded-md'>
                        <span className='m-0 text-xl flex items-center gap-1'>
                            {selectedMedia.length} Selected
                            <IconToolTip title='Clear all' onClick={clearSelectedMedia}>
                                <span className='material-icons text-scogoprimary font-medium align-middle text-font16 hover:text-scogoorange transition-colors'>
                                    highlight_off
                                </span>
                            </IconToolTip>
                        </span>
                    </div>
                )} */}
            </div>

            <div className='groupDetailsHeight overflow-auto flex-grow'>
                <GroupMedia
                    openedConversationId={chat_id}
                // selectedMedia={selectedMedia}
                // setCheckedTracker={setCheckedTracker}
                // checkedTracker={checkedTracker}
                />
            </div>
        </div>
    );
}